import {
    ADD_RATING_REQUEST,
    ADD_RATING_SUCCESS,
    ADD_RATING_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CandidateAddRatingAction = (data) => {
    return function (dispatch) {
      
      dispatch({
        type: ADD_RATING_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/update_interview`,
        method: "PUT",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(AddRatingPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: ADD_RATING_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };
  
  export const AddRatingPre = (data) => {
    toast.success("Successfully.");
  //   setTimeout(()=>{
  //     window.location.href = "/candidate-interview";
  //  },2000)
    return {
      type: ADD_RATING_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };